import React, { useEffect } from 'react';

import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';

import { ReactHookFormSelect } from 'common/components/form';

import * as actions from '../../actions';
import * as selectors from '../../selectors';

const Template = ({ control, disabled }) => {
    const { t } = useTranslation();

    const dispatch = useDispatch();
    const fetchTemplates = () => dispatch(actions.fetchTemplates());

    const templates = useSelector(selectors.getfetchTemplateCatalogsData);

    const getTemplateOptions = () => {
        const options = templates.map((item) => ({
            label: item.title,
            value: item.id,
        }));
        return [
            { disabled: true, label: t('Select a template'), value: '' },
            ...options,
        ];
    };

    useEffect(() => {
        fetchTemplates();
    }, []);

    return (
        <ReactHookFormSelect
            control={control}
            disabled={disabled}
            label={t('Template')}
            name="template"
            options={getTemplateOptions()}
        />
    );
};

Template.propTypes = {
    control: PropTypes.object,
    disabled: PropTypes.bool,
};

export default Template;
